/** This file comprises global functions for the rate-agreement-service */

import { Balance } from "../types/Balance";

/**
 * Dynamically calculate the remaining balance for a given debt
 *
 * @param rateAmount - the monthly installment amount
 * @param rateNumber - the total number of months (max is 12months)
 * @param completeBalance - the total debt plus the interest
 * @return returns the calculated remaining balance
 */
export const calculateRemainingBalance = (rateAmount: number | undefined, rateNumber: number | undefined, completeBalance: number) => {
    if (rateAmount === undefined || rateNumber === undefined) {
        return;
    }

    const instalmentPlan: number = rateAmount * rateNumber;
    const roundInstalmentPlan = parseFloat(Number(instalmentPlan).toFixed(2));
    // if the total debt would be fully paid with a given installment plan
    if (roundInstalmentPlan >= completeBalance) {
        return 0;
    }
    return completeBalance - instalmentPlan;
};

export function calculateCompleteBalance(debtBalance: Balance, settlementFee = 0) {
    return debtBalance.balance + settlementFee;
}

export const readLanguageFromCookie = () => {
    const cookies = document.cookie;
    const cookiearray = cookies.split(";");

    let language = "en";

    for (let i = 0; i < cookiearray.length; i++) {
        const name = cookiearray[i].split("=")[0];
        const value = cookiearray[i].split("=")[1];
        if (name.trim() === "Language" && /^[a-zA-Z]*$/.test(value)) {
            language = value;
        }
    }

    return language;
};
